import { z } from 'zod';

// ── Request (PUT) ────────────────────────────────────────────────────────────
//
// Both smsEnabled and qrEnabled are required in every PUT body.
// Partial updates are NOT supported (C-03).
// Both-false is shape-valid but rejected at the use case layer (R-03, 422).

export const UpdateTicketTypesConfigRequestSchema = z.object({
  smsEnabled: z.boolean(),
  qrEnabled: z.boolean(),
});

export type UpdateTicketTypesConfigRequest = z.infer<typeof UpdateTicketTypesConfigRequestSchema>;

// ── Response (GET / PUT) ─────────────────────────────────────────────────────
//
// JQ4-21 DEPENDS on this shape. Do NOT change it without a versioning decision.
// updatedAt is null when no config row has been persisted yet (default view, C-04).
// Response is FROZEN (C-01).

export const TicketTypesConfigResponseSchema = z.object({
  smsEnabled: z.boolean(),
  qrEnabled: z.boolean(),
  updatedAt: z.string().nullable(),
});

export type TicketTypesConfigResponse = z.infer<typeof TicketTypesConfigResponseSchema>;
